import React from 'react'
import useGaugeStyles from 'pages/HealthCenter/Report/BrainFunctionalConnectivity/Elements/components/style'
import {HEALTH_POINT} from 'constants/HealthConstant'

interface Props {
  index: number
  score: {
    low: number
    high: number
  }
}
function ProgressBar({index, score}: Props) {
  const {low, high} = score
  const classes = useGaugeStyles()

  return (
    <>
      {index === 3 ? (
        <div className={classes.botBar}>
          <div>
            <div className={classes.marker3} style={{left: `${low}%`}}>
              <span />
            </div>
            <div className={classes.marker3} style={{left: '50%'}}>
              <div />
            </div>
            <div className={classes.marker3} style={{left: `${high}%`}}>
              <span />
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.processBar}>
          <span className={classes.marker1} style={{top: `${low}%`}} />
          <span className={classes.marker1} style={{top: `${high}%`}} />
        </div>
      )}
    </>
  )
}
export default ProgressBar
